import { randomBetween } from '../config/gameConfig'

/** 词库：平台感 ID，避免「路人甲」类出戏昵称 */
const HANDLES = [
  'Reversi',
  'Othello',
  'Corner',
  'Midnight',
  'Silent',
  'Nova',
  'Apex',
  'Vector',
  'Cipher',
  'Zenith',
  'Polaris',
  'Nimbus',
  'Cascade',
  'Helix',
  'Monolith',
  'Slate',
  'Onyx',
  'Ivory',
  'Ember',
  'Frost',
]

const CN_PREFIX = [
  '深算',
  '落子',
  '星阵',
  '逆转',
  '边角',
  '稳局',
  '快攻',
  '残局',
  '棋道',
  '黑白',
]

const CN_SUFFIX = [
  '棋手',
  '选手',
  '大师',
  '学徒',
  '行者',
  '控场',
  '猎手',
  '守御',
]

function pick(arr) {
  return arr[Math.floor(Math.random() * arr.length)]
}

function digits(n) {
  let s = ''
  for (let i = 0; i < n; i++) s += Math.floor(Math.random() * 10)
  return s
}

/** 己方默认昵称（首次进入 / 一键随机） */
export function generatePlayerDisplayName() {
  const style = Math.random()
  if (style < 0.45) {
    return `${pick(HANDLES)}_${digits(4)}`
  }
  if (style < 0.75) {
    return `${pick(CN_PREFIX)}${pick(CN_SUFFIX)}`
  }
  return `Player${randomBetween(100000, 999999)}`
}

/** 匹配到的真人风格对手 */
export function generateOpponentDisplayName() {
  const style = Math.random()
  if (style < 0.35) {
    return `${pick(HANDLES)}${randomBetween(10, 99)}`
  }
  if (style < 0.65) {
    return `${pick(CN_PREFIX)}·${pick(['K', 'M', 'X', 'Pro'])}${randomBetween(1, 9)}`
  }
  if (style < 0.85) {
    return `uid_${randomBetween(10000000, 99999999)}`
  }
  return `${pick(CN_PREFIX)}${pick(CN_SUFFIX)}_${digits(3)}`
}